import { api } from 'pages/APIs';
import type { dynamicObj } from 'src/pages/assets';
import AbstractApiService from 'src/services/abstractApiService';
import { appSettingRequest, appCreateRequest } from 'src/types';

export default class AppsApiService extends AbstractApiService {
  api_key: string | null = null;
  public constructor() {
    super({});
  }

  public async getSettings(data: appSettingRequest): Promise<dynamicObj> {
    const querystring = this.encodeQueryData(data);
    return super.get(api.workflow_get_settings + '?' + querystring);
  }

  public async getApiVersion(): Promise<dynamicObj> {
    const options = {
      error: this.handleApiVersionError.bind(this),
    };
    return super.get(api.version, options);
  }

  protected handleApiVersionError(error: any): any {
    const message = error.message ?? 'service_down';
    const status =
      error.response && error.response.status ? error.response.status : 400;
    throw { status: status, message: message };
  }

  public async performInsightAction(
    settings: appCreateRequest,
  ): Promise<dynamicObj> {
    const token: string = await this.getToken();

    const formData = new FormData();
    formData.append('create', settings.create.toString());
    formData.append('subdomain_prefix', settings.domain_name.toLowerCase());

    return super.post(api.insight_actions, formData, {
      headers: {
        'X-API-KEY': token.replace('Bearer ', ''),
      },
    });
  }

  public async getAllVersions(): Promise<dynamicObj> {
    return super.get(api.service_versions);
  }
}
